import React from 'react';
import PropTypes from 'prop-types';

import { reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { validateStep7 } from './validations';

import { Field } from 'redux-form';
import InputGroup from '../InputGroup';
import Button from '../Button';
import TwoGroup from '../TwoGroup';
import DropDownSelect from '../DropDownSelect';

import {
    Container,
    ButtonGroupWrapper,
    MultipleGroupLastLarge,
    MultipleGroupFull
} from '../../containers/DefaultStyles/FormDetails';

class VoteRegistrationStep7Form extends React.Component {
    render() {
        return (
            <Container autocomplete="on" onSubmit={this.props.handleSubmit}>
                <MultipleGroupLastLarge>
                    <Field
                        name="prevAddress"
                        component={InputGroup}
                        type="text"
                        label="Prev Street No & Street"
                        placeholder="Street No & Street"
                        autocomplete="off"
                    />
                    <Field
                        name="prevUnit"
                        component={InputGroup}
                        type="text"
                        label="Prev Unit"
                        placeholder="Unit"
                        autocomplete="off"
                    />
                </MultipleGroupLastLarge>
                <MultipleGroupFull>
                    <Field
                        name="prevHomeCity"
                        component={InputGroup}
                        type="text"
                        label="Prev City"
                        placeholder="City"
                        autocomplete="off"
                    />
                </MultipleGroupFull>
                <MultipleGroupFull>
                    <Field
                        name="prevStateId"
                        component={DropDownSelect}
                        options={this.props.states}
                        defaultOption={'Choose'}
                        label="Prev State"
                        type="text"
                    />
                    <Field
                        name="prevPostalCode"
                        component={InputGroup}
                        type="text"
                        label="Prev Postal code"
                        placeholder="Postal Code"
                        autocomplete="off"
                        maxLength={5}
                    />
                </MultipleGroupFull>
                <ButtonGroupWrapper>
                    <TwoGroup>
                        <Button label="Back" onClick={this.props.onBack} />
                        <Button
                            primary={true}
                            type="submit"
                            label="Continue"
                            disabled={this.props.invalid}
                        />
                    </TwoGroup>
                </ButtonGroupWrapper>
            </Container>
        );
    }
}

VoteRegistrationStep7Form.propTypes = {
    onBack: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func,
    states: PropTypes.array
};

export default compose(
    connect(() => ({
        initialValues: {}
    })),
    reduxForm({
        form: 'voteRegistrationStep7Form',
        validate: validateStep7,
        destroyOnUnmount: false
    })
)(VoteRegistrationStep7Form);



// WEBPACK FOOTER //
// ./src/components/VoteRegistration/VoteRegistrationStep7Form.jsx